import React from 'react';

import { CgLogOff } from 'react-icons/cg';
import { useHistory } from 'react-router-dom';
import logout from '../../../modules/users/store/operators/logout';
import { useAppDispatch } from '../../infrastructure/store/hooks';

const LogoutButton = () => {
    const history = useHistory();
    const dispatch = useAppDispatch();

    const setLogout = () => {
        dispatch(logout(history));
    };

    return (
        <div className="oi-nav__link oi-nav__link--logout u-cursor" onClick={() => setLogout()}>
            <span className="oi-nav__icons">
                <CgLogOff />
            </span>
            <span>Logout</span>
        </div>
    );
};

export default LogoutButton;
